import { createMuiTheme, makeStyles } from "@material-ui/core/styles";
import * as colors from "@material-ui/core/colors";
import Typography from "@material-ui/core/Typography";
import React from "react";
import {
  accountdetail_path, accountdetailzeus_path,
} from "./Apollo_links";
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';

export const drawerWidth = 270;
export const menuButtonWidth = 35;
export const menuButtonMarginLeft = 10;
export const sideMenuCollapseWidth = (drawerWidth + menuButtonWidth + menuButtonMarginLeft) * 2 - 1;

export const apollo_theme = createMuiTheme({
  typography: {
    button: {
      textTransform: "none"
    },
    fontFamily: [
      "Noto Sans JP",
      "Lato",
      "游ゴシック Medium",
      "游ゴシック体",
      "Yu Gothic Medium",
      "YuGothic",
      "ヒラギノ角ゴ ProN",
      "Hiragino Kaku Gothic ProN",
      "メイリオ",
      "Meiryo",
      "ＭＳ Ｐゴシック",
      "MS PGothic",
      "sans-serif",
    ].join(","),
  },
  palette: {
    primary: {
      main: colors.blue[300],
      light: '#fff',
      contrastText: '#fff',
    },
    // secondary: {
    //   main: '#ff8a65', //オレンジ
    //   light: '#ffe57f', //黄色
    //   dark: '#4fc3f7', //水色
    // },
  },
});

export const apollo_view_theme = createMuiTheme({
  palette: {
    text: {
      disabled: "#000",
    },
  },
});

export const apollo_useStyles = makeStyles({
  mainroot: {
    // Width: "80%",
    display: "flex",
  },
  root: {
    Width: "80%",
    //display: "flex",
    marginTop: apollo_theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    marginTop: apollo_theme.spacing(2),
    maxHeight: 550,
    overflowY: 'auto',
  },
  billingTable: {
    tableLayout: "fixed",
  },
  billingTableCell: {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  link: {
    textDecoration: "none",
    color: apollo_theme.palette.text.secondary,
  },
  breadlink: {
    textDecoration: "none",
    color: apollo_theme.palette.text.primary,
  },
  fab: {
    zIndex: apollo_theme.zIndex.drawer + 1,
    position: 'fixed',
    bottom: apollo_theme.spacing(2),
    right: apollo_theme.spacing(2),

  },
  fab2: {
    zIndex: apollo_theme.zIndex.drawer + 1,
    position: 'fixed',
    bottom: apollo_theme.spacing(2),
    right: apollo_theme.spacing(10),
  },
  fab3: {
    zIndex: apollo_theme.zIndex.drawer + 1,
    position: 'fixed',
    bottom: apollo_theme.spacing(2),
    right: apollo_theme.spacing(18),
  },
  fab4: {
    zIndex: apollo_theme.zIndex.drawer + 1,
    display: 'none',
    position: 'fixed',
    bottom: apollo_theme.spacing(2),
    right: apollo_theme.spacing(10),
  },
  listItem: {
    padding: apollo_theme.spacing(1, 0),
    textalign: "left",
  },
  listItemText: {
    color: apollo_theme.palette.text.secondary,
  },
  cardaction: {
    marginLeft: "auto",
    marginRight: "10",
  },
  button: {
    marginTop: apollo_theme.spacing(3),
    marginLeft: apollo_theme.spacing(1),
  },
  buttonTop: {
    marginTop: apollo_theme.spacing(0),
    marginLeft: apollo_theme.spacing(1),
  },
  buttonMiddle: {
    marginTop: apollo_theme.spacing(1),
    marginLeft: apollo_theme.spacing(1),
  },
  textField: {
    marginLeft: apollo_theme.spacing(1),
    marginRight: apollo_theme.spacing(1),
    width: 200,
  },
  droparea: {
    alignContent: "center",
    width: "100%",
    height: 180,
    textalign: "center",
    backgroundColor: colors.grey[100],
    borderColor: colors.grey[400],
    borderStyle: "dashed",
  },
  dropArea2: {
    alignContent: "center",
    width: "100%",
    height: 100,
    textalign: "center",
    backgroundColor: colors.grey[100],
    borderColor: colors.grey[400],
    borderStyle: "dashed",
  },
  p: {
    paddingTop: 40,
    paddingLeft: apollo_theme.spacing(5),
  },
  p2: {
    paddingTop: 10,
    paddingLeft: apollo_theme.spacing(5),
  },
  tablescroll: {
    width: '10000',
    overflow: "scroll",
  },
  nested: {
    paddingLeft: apollo_theme.spacing(4),
  },
  selected: {
    paddingLeft: apollo_theme.spacing(4),
    color: apollo_theme.palette.text.primary,
  },
  accountbutton: {
    width: 'fit-content',
    maxWidth: '100%',
    justifyContent: "flex-start",
  },
  accountpaper: {
    position: 'absolute',
    width: '50%',
    padding: apollo_theme.spacing(2, 4, 3),
  },
  accountName: {
    overflow: 'hidden',
    maxWidth: '100%',
  },
  accountNameHidden: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  justifyContentLeft: {
    justifyContent: "start",
  },
  paper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: apollo_theme.palette.background.paper,
    boxShadow: apollo_theme.shadows[1],
    padding: apollo_theme.spacing(2, 4, 3),
  },
  paperNotify: {
    position: 'absolute',
    width: '80%',
    backgroundColor: apollo_theme.palette.background.paper,
    boxShadow: apollo_theme.shadows[1],
    padding: apollo_theme.spacing(2, 4, 3),
  },
  summarypaper: {
    padding: apollo_theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...apollo_theme.mixins.toolbar,
  },
  appBar: {
    zIndex: apollo_theme.zIndex.drawer + 1,
    color: apollo_theme.palette.text.secondary,
    backgroundColor: apollo_theme.palette.primary.light,
    transition: apollo_theme.transitions.create(["width", "margin"], {
      easing: apollo_theme.transitions.easing.sharp,
      duration: apollo_theme.transitions.duration.leavingScreen,
    }),
    boxShadow: apollo_theme.shadows[0],
  },
  appBarShift: {
    color: apollo_theme.palette.text.secondary,
    backgroundColor: apollo_theme.palette.primary.light,
    width: '100%',
    transition: apollo_theme.transitions.create(["width", "margin"], {
      easing: apollo_theme.transitions.easing.sharp,
      duration: apollo_theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    height: 35,
    width: menuButtonWidth,
    marginTop: 350,
    marginLeft: menuButtonMarginLeft,
    backgroundColor: colors.blue[300],
  },
  menuButtonHidden: {
    display: "none",
  },
  menuButtonIcon: {
    color: '#fff',
  },
  title: {
    flexGrow: 1,
    width: '13%',
  },
  editIcon: {
    color: apollo_theme.palette.primary.main
  },
  pageTitle: {
    marginBottom: apollo_theme.spacing(0),
  },
  dropdownStyle: {
    maxHeight: 'calc(100% - 150px)'
  },
  drawer: {
    width: drawerWidth,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    marginTop: 62,
    transition: apollo_theme.transitions.create("width", {
      easing: apollo_theme.transitions.easing.sharp,
      duration: apollo_theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: apollo_theme.transitions.create("width", {
      easing: apollo_theme.transitions.easing.sharp,
      duration: apollo_theme.transitions.duration.leavingScreen,
    }),
    width: apollo_theme.spacing(7),
    [apollo_theme.breakpoints.up("sm")]: {
      width: apollo_theme.spacing(9),
    },
  },
  drawerContainer: {
    overflow: 'auto',
  },
  rightDrawer: {
    width: '50%',
    whiteSpace: "nowrap",
    padding: 20,
  },
  appBarSpacer: apollo_theme.mixins.toolbar,
  sectionDesktop: {
    display: 'none',
    [apollo_theme.breakpoints.up('md')]: { // ブラウザ幅960px以上で表示
      display: 'flex',
    },
    marginRight: apollo_theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    // height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: apollo_theme.spacing(4),
    paddingBottom: apollo_theme.spacing(4),
    maxWidth: 3680,
  },
  account: {
    position: 'relative',
    minWidth: 0,
    marginRight: apollo_theme.spacing(2),
    marginLeft: apollo_theme.spacing(4),
    width: '100%',
    [apollo_theme.breakpoints.down("sm")]: {
      marginRight: apollo_theme.spacing(1),
      marginLeft: apollo_theme.spacing(1),
    },
  },
  fixedHeight: {
    height: 240,
  },
  fixedHeightGraph: {
    height: 590,
  },
  fixedHeightGrid: {
    // maxHeight: 300,
  },
  productroot: {
    backgroundColor: apollo_theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: apollo_theme.spacing(3),
    paddingTop: apollo_theme.spacing(3)
  },
  productCard: {
    height: '100%'
  },
  signinpaper: {
    marginTop: apollo_theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: apollo_theme.spacing(1),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: apollo_theme.spacing(1),
  },
  submit: {
    margin: apollo_theme.spacing(3, 0, 2),
  },
  errorMessage: {
    color: apollo_theme.palette.error.main,
  },
  grapharea: {
    width: '100%',
    height: 500,
  },
  piechart: {
    position: 'relative',
  },
  overlaypiechart: {
    display: 'block',
    width: "100%",
    height: 30,
    color: apollo_theme.palette.text.secondary,
    textAlign: 'center',
    verticalAlign: 'middle',
    position: 'absolute',
    marginTop: 60,
    top: 0,  /* chartArea top  */
    left: 0, /* chartArea left */
    fontSize: 20,
  },
  webButton: {
    textTransform: 'none',
  },
  flame: {
    maxWidth: 1000,
    maxHeight: 500,
    overflowY: "scroll",
  },
  blockMarginL: {
    marginLeft: 10,
  },
  radioGroup: {
    minWidth: 500,
  },
  radioSub: {
    marginTop: 10,
    marginLeft: 30,
  },
  radioSubmit: {
    width: 100,
  },
  scrollY: {
    overflowY: "scroll",
  },
  pointer: {
    cursor: "pointer",
  },
  chip: {
    margin: 4,
  },
  backdrop: {
    zIndex: apollo_theme.zIndex.drawer + 1,
    color: '#fff',
  },
  backdrop2: {
    zIndex: 100000,
    color: '#fff',
  },
  label11: {
    paddingTop: 40,
  },
  selectInModal: {
    width: "90%",
    margin: "auto"
  },
  cardActionButton: {
    marginTop: 20,
    justifyContent: 'center',
  },
  postPeriodStartDate: {
    paddingLeft: "47px !important",
  },
  postPeriodSeparate: {
    marginBottom: "30px !important",
  },
  msPreviewText: {
    '& *': {
      wordBreak: "break-all",
      whiteSpace: "normal",
    }
  },
  tableScrollContainer: {
    width: "100%",
    //   maxWidth: "3680px",
    overflowX: "auto",
    margin: "0 auto",
  },
  // tableScrollContainer:hover {
  // cursor: "grab";
  // },
  tableScrollContent: {
    width: "100%",
    height: "500px",
    select: "text",
  },
  // FAQエレメントを消す
  square: {
    width: "300px",
    height: "50px",
    background: "#FFFFFF",
    zIndex: 10000,
    position: 'fixed',
    bottom: apollo_theme.spacing(0),
    left: apollo_theme.spacing(0),
  },
  rowStyle: {
    marginTop: 20,
  },
  menuItemFocus: {
    "&:hover": {
      color: colors.blue[800],
    },
  },
  sideMenu: {
    height: "calc(100vh - 66px)",
    overflowX: "hidden",
    overflowY: "auto",
  },
  logo: {
    width: "clamp(100px, 25vw, 200px)", // 最大200px、ブラウザ幅800pxを下回ったら100pxを下限に徐々に縮小
    height: "auto",
    marginLeft: "1em",
  },
  userInfo: {
    display: 'none',
    [apollo_theme.breakpoints.up('lg')]: { // ブラウザ幅1280px以上で表示
      display: 'flex',
    },
    alignItems: "center",
  },
  UserProfileModalCard: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "90vh",
  },
  UserProfileModalCardContent: {
    marginTop: apollo_theme.spacing(2),
    maxWidth: 1000,
    flex: 1,
    overflowY: "scroll",
  },
  modalStyleWide: {
    [`@media (max-width: ${sideMenuCollapseWidth}px)`]: { // サイドメニュー自動折りたたみと同じタイミング
      width: "90%",
    },
  },
});

export const apollo_useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  link: {
    textDecoration: "none",
    color: apollo_theme.palette.text.secondary,
  },
  even: {
    background: "#fcfcfc",
  },
  none: {
    display: "inline",
  }
});

export type Option = {
  value: number,
  label: string,
}

export type OptionBool = {
  value: boolean,
  label: string,
}

export type StrOption = {
  value: string,
  label: string,
}

export const options_state = [
  { value: 1, label: '有効' },
  { value: 2, label: '一時停止' },
];

export const options_state_edit = [
  { value: 1, label: '有効' },
  { value: 2, label: '一時停止' },
  { value: 3, label: 'アーカイブ' },
];

export const options_state_edit_ms = [
  { value: 2, label: '有効' },
  { value: 3, label: '一時停止' },
  { value: 6, label: 'アーカイブ' },
];

export const options_state_new = [
  { value: 1, label: '有効' },
  { value: 3, label: 'アーカイブ' },
];

export const options_state_valid = [
  { value: 1, label: '有効' },
];

export const options_approval = [
  { value: true, label: '承認' },
  { value: false, label: '非承認' },
];

export const options_approval_new = [
  { value: 1, label: '未承認' },
  { value: 2, label: '承認' },
  { value: 3, label: '非承認' },
];

export const options_segment = [
  { value: 1, label: 'なし' },
  { value: 2, label: 'あり' },
];

export const options_possible = [
  { value: 0, label: '不可' },
  { value: 1, label: '可能' },
];

export const options_infostate = [
  { value: 1, label: '表示' },
  { value: 2, label: '非表示' },
  { value: 3, label: '下書き' },
];

export const CAMPAIGN_GOAL_NUMBER = {
  TARGET: 0,
  CLICK: 1,
  CV: 2,
  CPA: 3,
}

export const options_target = [
  { value: CAMPAIGN_GOAL_NUMBER.TARGET, label: 'ターゲットリーチ' },
  { value: CAMPAIGN_GOAL_NUMBER.CLICK, label: 'クリック数の最大化' },
  { value: CAMPAIGN_GOAL_NUMBER.CV, label: 'コンバージョン数の最大化' },
  { value: CAMPAIGN_GOAL_NUMBER.CPA, label: 'コンバージョンの最適化' },
];

export const options_bidding = [
  { value: false, label: '手動単価設定' },
  { value: true, label: '自動入札' },
];

export const options_clicktoaction = [
  { value: 1, label: '詳細はこちら' },
  { value: 2, label: '続きを見る' },
  { value: 3, label: '購入する' },
  { value: 4, label: '登録する' },
  { value: 5, label: '資料請求' },
  { value: 6, label: 'インストール' },
  { value: 7, label: 'ダウンロード' },
  { value: 8, label: 'お問い合わせ' },
  { value: 9, label: '予約する' },
  { value: 10, label: 'もっと見る' },
  { value: 11, label: 'サイトを見る' },
  { value: 12, label: '今すぐもらう' },
  { value: 13, label: '今すぐ予約' },
  { value: 14, label: '今すぐ購入' },
  { value: 15, label: '今すぐ登録' },
  { value: 16, label: '購入はこちら' },
  { value: 17, label: '申込はこちら' },
  { value: 18, label: '予約はこちら' },
  { value: 19, label: '登録はこちら' },
];

export const OS_TYPE_ZEUS_NUMBER = {
  PC: 0,
  IOS: 1,
  ANDROID: 2,
}

export const options_ostype_zeus = [
  { value: '0', label: 'PC' },
  { value: '1', label: 'iOS' },
  { value: '2', label: 'Android' },
];

export const options_ostype_zeus_number = [
  { value: OS_TYPE_ZEUS_NUMBER.PC, label: 'PC' },
  { value: OS_TYPE_ZEUS_NUMBER.IOS, label: 'iOS' },
  { value: OS_TYPE_ZEUS_NUMBER.ANDROID, label: 'Android' },
];

export const options_reviewstatus = [
  { value: '1', label: '未審査' },
  { value: '2', label: '承認' },
  { value: '3', label: '否認' },
];
export const options_reviewreason = [
  { value: 'null', label: 'なし' },
  { value: '0', label: 'なし' },
  { value: '1', label: '競合、取扱不可サービス' },
  { value: '2', label: '公序良俗に反する' },
  { value: '3', label: '広告関連法規に反する' },
  { value: '4', label: '媒体基準に反する' },
];

export const options_eventtype = [
  { value: 1, label: 'コンバージョン' },
  { value: 2, label: 'イベント(オーディエンス)' },
];

export const options_gender = [
  { value: '1', label: '男性' },
  { value: '2', label: '女性' },
  { value: '3', label: 'その他' },
];

export const options_pref = [
  { value: '1', label: '北海道' },
  { value: '2', label: '青森県' },
  { value: '3', label: '岩手県' },
  { value: '4', label: '宮城県' },
  { value: '5', label: '秋田県' },
  { value: '6', label: '山形県' },
  { value: '7', label: '福島県' },
  { value: '8', label: '茨城県' },
  { value: '9', label: '栃木県' },
  { value: '10', label: '群馬県' },
  { value: '11', label: '埼玉県' },
  { value: '12', label: '千葉県' },
  { value: '13', label: '東京都' },
  { value: '14', label: '神奈川県' },
  { value: '15', label: '新潟県' },
  { value: '16', label: '富山県' },
  { value: '17', label: '石川県' },
  { value: '18', label: '福井県' },
  { value: '19', label: '山梨県' },
  { value: '20', label: '長野県' },
  { value: '21', label: '岐阜県' },
  { value: '22', label: '静岡県' },
  { value: '23', label: '愛知県' },
  { value: '24', label: '三重県' },
  { value: '25', label: '滋賀県' },
  { value: '26', label: '京都府' },
  { value: '27', label: '大阪府' },
  { value: '28', label: '兵庫県' },
  { value: '29', label: '奈良県' },
  { value: '30', label: '和歌山県' },
  { value: '31', label: '鳥取県' },
  { value: '32', label: '島根県' },
  { value: '33', label: '岡山県' },
  { value: '34', label: '広島県' },
  { value: '35', label: '山口県' },
  { value: '36', label: '徳島県' },
  { value: '37', label: '香川県' },
  { value: '38', label: '愛媛県' },
  { value: '39', label: '高知県' },
  { value: '40', label: '福岡県' },
  { value: '41', label: '佐賀県' },
  { value: '42', label: '長崎県' },
  { value: '43', label: '熊本県' },
  { value: '44', label: '大分県' },
  { value: '45', label: '宮崎県' },
  { value: '46', label: '鹿児島県' },
  { value: '47', label: '沖縄県' },
];

export const options_area_pref = [
  {
    area: { value: 1, label: '北海道' },
    pref: [
      { value: 1, label: '北海道' },
    ]
  },
  {
    area: { value: 2, label: '東北' },
    pref: [
      { value: 2, label: '青森県' },
      { value: 3, label: '岩手県' },
      { value: 4, label: '宮城県' },
      { value: 5, label: '秋田県' },
      { value: 6, label: '山形県' },
      { value: 7, label: '福島県' },
    ]
  },
  {
    area: { value: 3, label: '関東' },
    pref: [
      { value: 8, label: '茨城県' },
      { value: 9, label: '栃木県' },
      { value: 10, label: '群馬県' },
      { value: 11, label: '埼玉県' },
      { value: 12, label: '千葉県' },
      { value: 13, label: '東京都' },
      { value: 14, label: '神奈川県' },
    ]
  },
  {
    area: { value: 4, label: '甲信越・北陸' },
    pref: [
      { value: 15, label: '新潟県' },
      { value: 16, label: '富山県' },
      { value: 17, label: '石川県' },
      { value: 18, label: '福井県' },
      { value: 19, label: '山梨県' },
      { value: 20, label: '長野県' },
    ]
  },
  {
    area: { value: 5, label: '東海' },
    pref: [
      { value: 21, label: '岐阜県' },
      { value: 22, label: '静岡県' },
      { value: 23, label: '愛知県' },
      { value: 24, label: '三重県' },
    ]
  },
  {
    area: { value: 6, label: '関西' },
    pref: [
      { value: 25, label: '滋賀県' },
      { value: 26, label: '京都府' },
      { value: 27, label: '大阪府' },
      { value: 28, label: '兵庫県' },
      { value: 29, label: '奈良県' },
      { value: 30, label: '和歌山県' },
    ]
  },
  {
    area: { value: 7, label: '中国' },
    pref: [
      { value: 31, label: '鳥取県' },
      { value: 32, label: '島根県' },
      { value: 33, label: '岡山県' },
      { value: 34, label: '広島県' },
      { value: 35, label: '山口県' },
    ]
  },
  {
    area: { value: 8, label: '四国' },
    pref: [
      { value: 36, label: '徳島県' },
      { value: 37, label: '香川県' },
      { value: 38, label: '愛媛県' },
      { value: 39, label: '高知県' },
    ]
  },
  {
    area: { value: 9, label: '九州・沖縄' },
    pref: [
      { value: 40, label: '福岡県' },
      { value: 41, label: '佐賀県' },
      { value: 42, label: '長崎県' },
      { value: 43, label: '熊本県' },
      { value: 44, label: '大分県' },
      { value: 45, label: '宮崎県' },
      { value: 46, label: '鹿児島県' },
      { value: 47, label: '沖縄県' },
    ]
  },
]

export const options_manualType = [
  { value: 1, label: "管理画面マニュアル" },
  { value: 2, label: "一括アップロード仕様書" },
  { value: 3, label: "セールスシート" },
];

export const options_mimetype_manual = [
  { value: 1, label: 'application/pdf' },
  { value: 2, label: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
];

export const options_extension_manual = [
  { value: 1, label: '.pdf' },
  { value: 2, label: '.xlsx' },
];

export const options_mimetype = [
  { value: '1', label: 'image/png' },
  { value: '2', label: 'image/jpeg' },
  { value: '3', label: 'image/gif' },
];

export const options_mimetype_zeus = [
  { value: '2', label: 'image/jpeg' },
  { value: '3', label: 'image/gif' },
];

export const option_os = [
  { value: '1', label: 'iOS' },
  { value: '2', label: 'Android' },
];

export const options_platform = [
  { value: 'zeus', label: '1' },
  { value: 'dadnw', label: '2' },
  { value: 'google', label: '3' },
  { value: 'facebook', label: '4' },
  { value: 'twitter', label: '5' },
  { value: 'yahoo', label: '6' },
];

export const options_matchtype = [
  { value: 1, label: "前方一致" },
  { value: 2, label: "部分一致" },
];

export const options_report_kind = [
  { value: '1', label: 'アカウント単位' },
  { value: '2', label: 'キャンペーン単位' },
  { value: '3', label: '広告グループ単位' },
  { value: '4', label: '広告別' },
];

export const options_report_kind2 = [
  { value: '1', label: 'Performance' },
  { value: '2', label: 'PerformanceCV' },
];

{/*TODO: Apollo v2.0 Zeus面のパス移行後に修正*/
}
export const options_platformdetail_path = [
  { value: '1', label: accountdetailzeus_path },
  { value: '2', label: accountdetail_path + "/ms/" },
];

export const options_number = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' },
  { value: '31', label: '31' },
  { value: '32', label: '32' },
  { value: '33', label: '33' },
  { value: '34', label: '34' },
  { value: '35', label: '35' },
  { value: '36', label: '36' },
  { value: '37', label: '37' },
  { value: '38', label: '38' },
  { value: '39', label: '39' },
  { value: '40', label: '40' },
  { value: '41', label: '41' },
  { value: '42', label: '42' },
  { value: '43', label: '43' },
  { value: '44', label: '44' },
  { value: '45', label: '45' },
  { value: '46', label: '46' },
  { value: '47', label: '47' },
  { value: '48', label: '48' },
  { value: '49', label: '49' },
  { value: '50', label: '50' },
  { value: '51', label: '51' },
  { value: '52', label: '52' },
  { value: '53', label: '53' },
  { value: '54', label: '54' },
  { value: '55', label: '55' },
  { value: '56', label: '56' },
  { value: '57', label: '57' },
  { value: '58', label: '58' },
  { value: '59', label: '59' },
  { value: '60', label: '60' },
  { value: '61', label: '61' },
  { value: '62', label: '62' },
  { value: '63', label: '63' },
  { value: '64', label: '64' },
  { value: '65', label: '65' },
  { value: '66', label: '66' },
  { value: '67', label: '67' },
  { value: '68', label: '68' },
  { value: '69', label: '69' },
  { value: '70', label: '70' },
  { value: '71', label: '71' },
  { value: '72', label: '72' },
  { value: '73', label: '73' },
  { value: '74', label: '74' },
  { value: '75', label: '75' },
  { value: '76', label: '76' },
  { value: '77', label: '77' },
  { value: '78', label: '78' },
  { value: '79', label: '79' },
  { value: '80', label: '80' },
  { value: '81', label: '81' },
  { value: '82', label: '82' },
  { value: '83', label: '83' },
  { value: '84', label: '84' },
  { value: '85', label: '85' },
  { value: '86', label: '86' },
  { value: '87', label: '87' },
  { value: '88', label: '88' },
  { value: '89', label: '89' },
  { value: '90', label: '90' },
  { value: '91', label: '91' },
  { value: '92', label: '92' },
  { value: '93', label: '93' },
  { value: '94', label: '94' },
  { value: '95', label: '95' },
  { value: '96', label: '96' },
  { value: '97', label: '97' },
  { value: '98', label: '98' },
  { value: '99', label: '99' },
  { value: '100', label: '100' },
];

export const options_age = [
  { value: 16, label: '16' },
  { value: 17, label: '17' },
  { value: 18, label: '18' },
  { value: 19, label: '19' },
  { value: 20, label: '20' },
  { value: 21, label: '21' },
  { value: 22, label: '22' },
  { value: 23, label: '23' },
  { value: 24, label: '24' },
  { value: 25, label: '25' },
  { value: 26, label: '26' },
  { value: 27, label: '27' },
  { value: 28, label: '28' },
  { value: 29, label: '29' },
  { value: 30, label: '30' },
  { value: 31, label: '31' },
  { value: 32, label: '32' },
  { value: 33, label: '33' },
  { value: 34, label: '34' },
  { value: 35, label: '35' },
  { value: 36, label: '36' },
  { value: 37, label: '37' },
  { value: 38, label: '38' },
  { value: 39, label: '39' },
  { value: 40, label: '40' },
  { value: 41, label: '41' },
  { value: 42, label: '42' },
  { value: 43, label: '43' },
  { value: 44, label: '44' },
  { value: 45, label: '45' },
  { value: 46, label: '46' },
  { value: 47, label: '47' },
  { value: 48, label: '48' },
  { value: 49, label: '49' },
  { value: 50, label: '50' },
  { value: 51, label: '51' },
  { value: 52, label: '52' },
  { value: 53, label: '53' },
  { value: 54, label: '54' },
  { value: 55, label: '55' },
  { value: 56, label: '56' },
  { value: 57, label: '57' },
  { value: 58, label: '58' },
  { value: 59, label: '59' },
  { value: 60, label: '60' },
  { value: 61, label: '61' },
  { value: 62, label: '62' },
  { value: 63, label: '63' },
  { value: 64, label: '64' },
  { value: 65, label: '65' },
  { value: 66, label: '66' },
  { value: 67, label: '67' },
  { value: 68, label: '68' },
  { value: 69, label: '69' },
  { value: 70, label: '70' },
  { value: 71, label: '71' },
  { value: 72, label: '72' },
  { value: 73, label: '73' },
  { value: 74, label: '74' },
  { value: 75, label: '75' },
  { value: 76, label: '76' },
  { value: 77, label: '77' },
  { value: 78, label: '78' },
  { value: 79, label: '79' },
];

export const options_upload_state = [
  { value: 1, label: '処理待ち' },
  { value: 2, label: '処理中' },
  { value: 3, label: '正常処理' },
  { value: 4, label: '異常終了' },
];

export const options_request_state = [
  { value: 1, label: '処理待ち' },
  { value: 2, label: '処理中' },
  { value: 3, label: '正常終了' },
  { value: 4, label: '異常終了' },
];

export const options_batch_status = [
  { value: 0, label: '処理待ち' },
  { value: 1, label: '処理中' },
  { value: 2, label: '正常処理' },
  { value: 3, label: '異常終了' },
];

export const options_reviewstatus_for_view = [
  { value: 0, label: '審査中' },
  { value: 1, label: '配信可' },
  { value: 2, label: '配信不可' },
  { value: 3, label: '否認' },
  { value: 4, label: '未審査' },
];

export const options_reviewstatus_ad_client_icon = [
  { value: 1, label: '審査中' },
  { value: 2, label: '審査OK' },
  { value: 3, label: '審査NG' },
];

export const options_reviewreason_ad_client_icon = [
  { value: 1, label: '競合、取扱不可サービス' },
  { value: 2, label: '公序良俗に反する' },
  { value: 3, label: '広告関連法規に反する' },
  { value: 4, label: '媒体基準に反する' },
];

export const options_input_type = [
  { value: "CONDITION", label: "条件指定" },
  { value: "FILE", label: "ファイル" },
];

export const options_status = [
  { value: "AVAILABLE", label: "利用可能" },
  { value: "PROCESSING", label: "処理中" },
  { value: "INVALID", label: "無効" },
  { value: "VALIDATING", label: "検証中" },
  { value: "UNAVAILABLE", label: "利用不可" },
];

export const options_use_preference = [
  { value: "TARGET", label: "カスタムリストに利用" },
  { value: "EXCEPT", label: "除外リストに利用" },
];

export const options_usage = [
  { value: "TEMPORARY", label: "見積用" },
  { value: "PRODUCTION", label: "本番用" },
];

export const options_affinity_usage = [
  { value: "TEMPORARY", label: "非公開" },
  { value: "PRODUCTION", label: "公開" },
];

export const options_targeting = [
  { value: 1, label: "利用可" },
  { value: 2, label: "利用不可" },
];

export const options_report_kind3 = [
  { value: 1, label: "実績レポート" },
  // {value: 2, label: "分析レポート"},
];

export const options_performance_report_ad_kind = [
  { value: 1, label: "キャンペーン" },
  { value: 2, label: "広告グループ" },
  { value: 3, label: "広告" },
];

export const options_analysis_report_ad_kind = [
  { value: 2, label: "広告グループ" },
];

export const options_performance_report_totaling_period_kind = [
  { value: 1, label: "合算" },
  { value: 2, label: "月" },
  { value: 3, label: "日" },
  { value: 4, label: "時間" },
];

export const options_analysis_report_totaling_period_kind = [
  { value: 1, label: "合算" },
  { value: 2, label: "月" },
  { value: 3, label: "日" },
];

export const options_analysis_report_option = [
  { value: 1, label: "年代×性別" },
  { value: 2, label: "都道府県別" },
];

export const options_extract_period_kind = [
  { value: 1, label: "当月" },
  { value: 2, label: "前月" },
  { value: 3, label: "前日" },
  { value: 4, label: "過去7日間" },
  { value: 5, label: "カスタム" },
];

export const options_schedule_kind = [
  { value: 1, label: "繰り返し" },
  { value: 2, label: "日付指定" },
  { value: 3, label: "即時" },
];

export const weekKeys = ["月", "火", "水", "木", "金", "土", "日"];

export const platformPathMaster = ["", "zeus", "ms"];
export const menuNameMaster = ["", "パフォーマンス広告", "メール広告"];

export const zeroDate = "0001-01-01T00:00:00Z";
export const continuouslyDate = "2099-12-31T23:59";

export const options_display_parent_archive_adgroups = [
  { value: 0, label: '親キャンペーンのステータスがアーカイブ' },
  { value: 1, label: '親キャンペーンのステータスがアーカイブ以外' },
];

export const options_display_parent_archive_ads = [
  { value: 0, label: '親キャンペーン・親広告グループのステータスがアーカイブ' },
  { value: 1, label: '親キャンペーン・親広告グループのステータスがアーカイブ以外' },
];

// Zeus関連
export const ZEUS_DELIVERY_TYPE = {
  /** Performance Network */
  PERFORMANCE: 1,
  /** docomo connecting path DSP */
  DSP: 2,
}
export const ZEUS_DELIVERY_TYPE_STRING = {
  PERFORMANCE: "Performance Network",
  DSP: "docomo connecting path DSP",
}
export const ZEUS_DELIVERY_TYPE_STRING_SHORT = {
  PERFORMANCE: "Performance",
  DSP: "コネパスDSP",
}
export const options_zeus_campaign_type = [
  { value: ZEUS_DELIVERY_TYPE.PERFORMANCE, label: ZEUS_DELIVERY_TYPE_STRING.PERFORMANCE },
  { value: ZEUS_DELIVERY_TYPE.DSP, label: ZEUS_DELIVERY_TYPE_STRING.DSP },
];
export const options_zeus_campaign_type_short = [
  { value: ZEUS_DELIVERY_TYPE.PERFORMANCE, label: ZEUS_DELIVERY_TYPE_STRING_SHORT.PERFORMANCE },
  { value: ZEUS_DELIVERY_TYPE.DSP, label: ZEUS_DELIVERY_TYPE_STRING_SHORT.DSP },
];

export const ZEUS_DOMAIN_SETTING = {
  UNSPECIFIED: 0,
  DOMAIN_EXCLUSION: 1,
  DOMAIN_SPECIFICATION: 2,
}

export const ZEUS_BILLING_TYPE = {
  CPC_CPM: 1,
  CPM: 2,
}
export const options_zeus_billing_type = [
  { value: ZEUS_BILLING_TYPE.CPC_CPM, label: "CPC/CPM" },
  { value: ZEUS_BILLING_TYPE.CPM, label: "CPM" },
];

export const ZEUS_PMP_TYPE = {
  OPEN_AUCTION: null,
  PLACEMENT_DESIGNATION: 1,
  PREMIUM_PLACEMENT_DESIGNATION: 2,
}

export const options_zeus_pmp_type = [
  { value: ZEUS_PMP_TYPE.OPEN_AUCTION, label: "オープンオークション" },
  { value: ZEUS_PMP_TYPE.PLACEMENT_DESIGNATION, label: "プレースメント指定" },
  { value: ZEUS_PMP_TYPE.PREMIUM_PLACEMENT_DESIGNATION, label: "プレミアムプレースメント指定" },
];


// MS関連
export const options_ms_campaign_type = [
  { value: 1, label: "メッセージS" },
  { value: 2, label: "リアルタイムメッセージS" },
];

export const options_ms_billing_type = [
  { value: 1, label: "CPC" },
  { value: 2, label: "CPM" },
];

export const options_ms_bid_ctgry = [
  { value: 1, label: "CPC" },
  { value: 3, label: "CPM" },
];

export const option_setpoint_attribute_type = [
  { value: 0, label: "全部" },
  { value: 1, label: "外部計測ツール" },
  { value: 2, label: "トラッキングタグ" },
];


export const option_setpoint_attribute = [
  { value: 1, label: "トラッキングタグによる測定" },
  { value: 2, label: "外部計測ツールによる測定" },
];

export const option_crasset_format_type = [
  { value: 4, label: "シングル画像" },
  { value: 5, label: "カスタム画像" },
];

export const option_setpoint_cv_category = [
  { value: 1, label: "本CV" },
  { value: 2, label: "中間CV" },
];

export const option_setpoint_action_category = [
  { value: 1, label: "ページ遷移" },
  { value: 2, label: "ボタン押下" },
  { value: 3, label: "カート追加" },
  { value: 4, label: "アプリインストール" },
  { value: 5, label: "口座開設/契約完了" },
  { value: 6, label: "購入/申込完了（有料CV）" },
  { value: 7, label: "資料請求/会員登録/申込完了（無料CV）" },
];

export const option_zeus_adtype = [
  { value: 1, label: "レスポンシブ広告(画像)", deliveryType: [1, 2] },
  { value: 2, label: "バナー広告(画像)", deliveryType: [2] },
  // 以下は現時点で未対応
  // {value: 3, label: "タグアセット広告(画像)"},
  // {value: 4, label: "レスポンシブ広告(動画)"},
  // {value: 5, label: "バナー広告(動画)"},
  { value: 6, label: "タグアセット広告(動画)", deliveryType: [1, 2] },
];

export const ZEUS_AD_TYPE = {
  RESPONSIVE_IMAGE: 1,
  BANNER_IMAGE: 2,
}

export const Copyright = () => {
  return (
    <Container maxWidth="xl">
      <Grid>
        <Grid container spacing={2} alignItems="center" justify="center">
          <Grid item>
            <Link href={process.env.REACT_APP_POLICYA} variant="caption" color="textSecondary" target="_policya">
              プライバシーポリシー
            </Link>
          </Grid>
        </Grid>
        <Typography variant="body2" color="textSecondary" align="center">
          {"Copyright © "}
          CARTA ZERO Inc. All Rights Reserved
        </Typography>
      </Grid>
    </Container>
  );
};

export const valueToOption = function (value: any, options: Array<{ value: any; label: string }>): { value: any; label: string } {
  let option = options.find(option => option.value === value)
  if (!option) {
    return options[0]
  } else {
    return option
  }
}

export const valueToOptionNull = function (value: any, options: Array<{ value: any; label: string }>): { value: any; label: string } | null {
  let option = options.find(option => option.value === value)
  if (!option) {
    return null;
  } else {
    return option
  }
}

export function getValueLineStyle() {
  const marginBottom = 10;
  const marginLeft = 10;
  return {
    marginBottom: marginBottom,
    marginLeft: marginLeft,
  };
}

export function getValueCautionStyle() {
  const marginLeft = 20;
  const fontSize = 12;
  return {
    marginLeft: marginLeft,
    fontSize: fontSize,
  };
}

export function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

export function getDialogStyle() {
  const padding = 15;
  const width = 600;
  const height = 550;
  const overflow = "scroll";
  return {
    padding: padding,
    width: width,
    height: height,
    overflow: overflow,
  };
}

export function getMenuDialogStyle() {
  const width = 500;
  const height = 230;
  return {
    width: width,
    height: height,
  };
}

export function getCampaignDialogStyle() {
  const width = 1150;
  const height = 600;
  const padding = 15;
  return {
    width: width,
    height: height,
    padding: padding,
  };
}

export function toUpperInitial(text: string): string {
  return text.charAt(0).toUpperCase() + text.substring(1);
}

export const geoSegment_useStyles = makeStyles({
  areaSetting_h1: {
    textAlign: "left",
    fontSize: "16px",
    color: "#4897D8",
    background: "#F1F1F2",
    padding: "15px",
    paddingLeft: "30px",
    marginBottom: "15px"
  },
  areaSetting_th: {
    textAlign: "left",
    padding: "10px"
  },
  areaSetting_td1: {
    padding: "10px"
  },
  areaSetting_td2: {
    padding: "10px",
    background: "#FFF4EA"
  },
  areaSetting_hr: {
    color: "blue",
    width: "100%",
    height: "0",
    border: "0",
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.3)"
  },
  areaSetting_div1: {
    display: "flex",
    marginTop: "15px",
    marginBottom: "15px"
  },
  areaSetting_half_width: {
    width: "50%"
  },
  areaSetting_table: {
    width: "100%",
    marginTop: "10px"
  }
});
